module.exports = {"TXTWCL_Resend_code":{"id":"TXTWCL_Resend_code","defaultMessage":"Send kode igen","track":"Resend code"}}